import { useState } from "react";
import { Link } from "react-router-dom";

import { MenuDrawer } from "./MenuDrawer.js";

interface Props {
  /** "home" drops the redundant banner artwork and floats the controls
   *  over the landing image, keeping them in the banner's usual position. */
  variant?: "home" | "page";
}

export function Header({ variant = "page" }: Props) {
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = variant === "home";

  return (
    <>
      <header className={isHome ? "banner banner-home" : "banner"}>
        <button
          type="button"
          className="hamburger"
          aria-label="Open menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(true)}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        {!isHome && (
          <Link to="/" className="banner-brand" aria-label="JivaSeva home">
            <img
              src="/banner.png"
              alt="ईशावास्यमिदं सर्वम् — Everything is pervaded by the Divine. JivaSeva — Life Takes Care of Life"
              className="banner-img"
            />
          </Link>
        )}
      </header>

      <MenuDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
